import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { ButtonLoader } from "Components";
import { newAuthService } from "Service/Axios";
import { FORM_BUILDER_FORM_SETTINGS_SAVE_URL } from "Constant/api";
import { DEFAULT_MODULE_TYPE, IMAGE_TYPES } from "Constant/constants";
import { formatDateLocal, uploadHandler } from "Utils";

export const GeneralSettings = ({ formDetails }) => {
  const { t } = useTranslation();

  const { formId } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    loginRequired: true,
    enableForm: true,
    enableForm: true,
    isBanner: false,
    universityLogo: "",
    universityBanner: "",
    headerColor: "",
    startDate: "",
    endDate: "",
  });

  const {
    loginRequired,
    enableForm,
    isBanner,
    universityLogo,
    universityBanner,
    headerColor,
    startDate,
    endDate,
  } = formData;

  useEffect(() => {
    if (formDetails && formDetails?.formSetting) {
      setFormData({
        loginRequired: formDetails.loginRequired,
        enableForm: formDetails.enableForm,
        isBanner: formDetails.banner,
        universityLogo: formDetails?.formSetting?.logoURL || "",
        universityBanner: formDetails?.formSetting?.bannerURL || "",
        headerColor: formDetails?.formSetting?.headerColor || "",
        startDate:
          formDetails?.formSetting?.startForm &&
          formatDateLocal(formDetails?.formSetting?.startForm),
        endDate:
          formDetails?.formSetting?.endForm &&
          formatDateLocal(formDetails?.formSetting?.endForm),
      });
    }
  }, [formDetails]);

  // On Change
  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleChangeEnableForm = async (e) => {
    setFormData((prev) => ({
      ...prev,
      enableForm: e.target.checked,
    }));
    await onSaveSettings(e.target.checked, loginRequired);
  };

  const handleChangeLoginRequired = async (e) => {
    setFormData((prev) => ({
      ...prev,
      loginRequired: e.target.checked,
    }));
    await onSaveSettings(enableForm, e.target.checked);
  };

  const handleUploadImage = async (e) => {
    setLoading(true);
    const fieldName = e.target.name;
    try {
      const response = await uploadHandler(
        e,
        DEFAULT_MODULE_TYPE.universityLogo,
        IMAGE_TYPES
      );
      if (response && response.url) {
        setFormData((prev) => ({
          ...prev,
          [fieldName]: response.url,
        }));
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };

  const handleRemoveImage = (fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: "",
    }));
  };

  // On Submit
  const onSaveSettings = async (isEnableForm, isLoginRequird) => {
    setLoading(true);
    try {
      const payload = {
        formId,
        formSettingRequired: true,
        loginRequired: isLoginRequird,
        enableForm: isEnableForm,
        banner: isBanner,
        formSetting: {
          timelimit: true,
          logoURL: universityLogo,
          bannerURL: universityBanner,
          headerColor,
          startForm: startDate,
          endForm: endDate,
          // welcomeText: "",
          // startButtonText: "",
          // backgroundImageURL: "",
          // afterSubmissonText: "",
        },
      };
      await newAuthService(
        FORM_BUILDER_FORM_SETTINGS_SAVE_URL,
        "POST",
        payload
      );
      toast.success(t("common.messages.notification.success.updateForm"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="p-3 rounded-2 bg-white height-equal border">
      <Form.Check
        className="form-switch-success"
        reverse
        type="switch"
        id="custom-switch"
        label={t("common.label.enableForm")}
        checked={enableForm}
        onChange={handleChangeEnableForm}
      />
      <Form.Check
        className="form-switch-success"
        reverse
        type="switch"
        id="custom-switch"
        label={t("common.label.loginRequired")}
        name="loginRequired"
        checked={loginRequired}
        onChange={handleChangeLoginRequired}
      />
      <Form.Check
        className="form-switch-success"
        reverse
        type="switch"
        id="custom-switch"
        label={t("common.label.isBanner")}
        name="isBanner"
        checked={isBanner}
        onChange={handleChange}
      />
      <div className="form-setting-row bg-light rounded-2 border p-3 mb-4">
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <Form.Group className="mb-3" controlId="universityLogo">
              <Form.Label>
                {t("common.label.addUniversityLogo")}{" "}
                <small>({t("common.label.fileSize")} 5 MB)</small>
              </Form.Label>
              <div className="file-input-box bg-white border rounded position-relative">
                {universityLogo ? (
                  <>
                    <img
                      src={universityLogo}
                      alt="University Logo Preview"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "contain",
                        padding: "20px",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveImage("universityLogo")}
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        backgroundColor: "rgba(255, 0, 0, 0.7)",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                        fontSize: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title="Remove image"
                    >
                      ✕
                    </button>
                  </>
                ) : (
                  <label
                    htmlFor="fileLogo"
                    className="d-block p-5 text-center"
                    style={{ cursor: "pointer" }}
                  >
                    <span className="material-symbols-outlined">
                      cloud_upload
                    </span>
                    <h5 className="mb-0">
                      <strong>{t("common.placeHolder.chooseFile")}</strong>{" "}
                      {t("common.label.or")}{" "}
                      <strong>{t("common.placeHolder.dragHere")}</strong>
                    </h5>
                    <small>{t("common.label.fileSize")} 5 MB</small>
                  </label>
                )}
                <input
                  type="file"
                  id="fileLogo"
                  className="d-none"
                  name="universityLogo"
                  onChange={handleUploadImage}
                />
              </div>
            </Form.Group>
          </Col>
          {isBanner && (
            <Col lg={12} md={12} sm={12} xs={12}>
              <Form.Group className="mb-3" controlId="universityBanner">
                <Form.Label>
                  {t("common.label.addUniversityBanner")}{" "}
                  <small>({t("common.label.fileSize")} 5 MB)</small>
                </Form.Label>
                <div className="file-input-box bg-white border rounded position-relative">
                  {universityBanner ? (
                    <>
                      <img
                        src={universityBanner}
                        alt="University Banner Preview"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          padding: "0",
                          display: "block",
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => handleRemoveImage("universityBanner")}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          backgroundColor: "rgba(255, 0, 0, 0.7)",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                          fontSize: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        title="Remove image"
                      >
                        ✕
                      </button>
                    </>
                  ) : (
                    <label
                      htmlFor="fileBanner"
                      className="d-block p-5 text-center"
                      style={{ cursor: "pointer" }}
                    >
                      <span className="material-symbols-outlined">
                        cloud_upload
                      </span>
                      <h5 className="mb-0">
                        <strong>{t("common.placeHolder.chooseFile")}</strong>{" "}
                        {t("common.label.or")}{" "}
                        <strong>{t("common.placeHolder.dragHere")}</strong>
                      </h5>
                      <small>{t("common.label.fileSize")} 5 MB</small>
                    </label>
                  )}
                  <input
                    type="file"
                    id="fileBanner"
                    className="d-none"
                    name="universityBanner"
                    onChange={handleUploadImage}
                  />
                </div>
              </Form.Group>
            </Col>
          )}

          <Col lg={12} md={12} sm={12} xs={12}>
            <Form.Group className="mb-3" controlId="headerColor">
              <Form.Label>{t("common.label.headerColor")}</Form.Label>
              <Form.Control
                type="color"
                aria-describedby=""
                name="headerColor"
                value={headerColor}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>
      </div>

      <div className="form-setting-row bg-light rounded-2 border p-3 mb-4">
        <Row>
          <Col lg={6} md={6} sm={6} xs={12}>
            <Form.Group className="mb-3" controlId="start-date">
              <Form.Label>{t("common.label.startDate")}</Form.Label>
              <Form.Control
                type="date"
                aria-describedby=""
                name="startDate"
                value={startDate}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={6} xs={12}>
            <Form.Group className="mb-3" controlId="end-date">
              <Form.Label>{t("common.label.endDate")}</Form.Label>
              <Form.Control
                type="date"
                aria-describedby=""
                name="endDate"
                value={endDate}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>
      </div>

      {!loading ? (
        <Button
          variant="primary"
          onClick={() => onSaveSettings(enableForm, loginRequired)}
        >
          {t("common.button.save")}
        </Button>
      ) : (
        <ButtonLoader />
      )}
    </div>
  );
};
